let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fCfXS")).then(() => parcelRequire('8YBUu'));